import type { Connector, ConnectorType } from '@/types'
import { CONNECTOR_TYPES } from './connectorConstants'
import { ConnectorCard } from './ConnectorCard'

interface ConnectorCatalogProps {
  connectors: Connector[]
  onCardClick: (type: ConnectorType) => void
  canManage: boolean
  sonarQubeEnabled?: boolean
  unavailableReasons?: Partial<Record<ConnectorType, string>>
}

export function ConnectorCatalog({
  connectors,
  onCardClick,
  canManage,
  sonarQubeEnabled = false,
  unavailableReasons = {},
}: ConnectorCatalogProps) {
  const isEnabled = (type: ConnectorType) =>
    type === 'SonarQube' ? sonarQubeEnabled : connectors.some((c) => c.type === type)

  const enabledTypes = CONNECTOR_TYPES.filter(isEnabled)

  const availableTypes = CONNECTOR_TYPES.filter((type) => !isEnabled(type))

  const renderGrid = (types: ConnectorType[]) => (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {types.map((type) => {
        const connector = connectors.find((c) => c.type === type)
        return (
          <ConnectorCard
            key={type}
            connectorType={type}
            connector={connector}
            onClick={() => onCardClick(type)}
            canManage={canManage}
            isConnectedOverride={type === 'SonarQube' ? sonarQubeEnabled : undefined}
            unavailableReason={unavailableReasons[type]}
          />
        )
      })}
    </div>
  )

  return (
    <div className="flex flex-col gap-8">
      {enabledTypes.length > 0 && (
        <div className="flex flex-col gap-3">
          <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
            Enabled
          </h2>
          {renderGrid(enabledTypes)}
        </div>
      )}

      <div className="flex flex-col gap-3">
        {enabledTypes.length > 0 && (
          <h2 className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
            Available
          </h2>
        )}
        {renderGrid(availableTypes)}
      </div>
    </div>
  )
}